import { SurveyAnswerJson, SurveyQuestionJson } from "@performyard/service-contracts";

export enum AUTHOR_SURVEY_MODALS {
	SUBMIT_INCOMPLETE_SURVEY = "SUBMIT_INCOMPLETE_SURVEY",
}

export interface AuthorSurveyStore {
	answers: { [key: string]: SurveyAnswerJson["value"] };
	questions: SurveyQuestionJson[];
	errors: Record<string, string>;
	modal: AUTHOR_SURVEY_MODALS | null;
	setters: {
		setAnswer: (questionId: string, answer: SurveyAnswerJson["value"]) => void;
		setQuestions: (questions: SurveyQuestionJson[]) => void;
		setErrors: (errors: Record<string, string>) => void;
		setModal: (modal: AUTHOR_SURVEY_MODALS | null) => void;
	};
	actions: {
		validateAnswers: (
			onValid?: (answers: Record<string, SurveyAnswerJson["value"]>) => void,
			onInvalid?: () => void
		) => void;
		clearAnswers: () => void;
	};
}
